'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagNaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-5.96046e-08 2.86102e-06H28C28 2.86102e-06 28 0.895433 28 2C28 8 28 14 28 20H-7.62939e-06C-7.62939e-06 20 -9.53674e-07 19.1046 -9.53674e-07 18C-9.53674e-07 12 -6.05048e-06 6 -5.96046e-08 2.86102e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-9.53674e-07 13.3333L28 2.86102e-06H-5.96046e-08L-9.53674e-07 13.3333Z",
          fill: "#0C4799"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66667 6L3.64618 7.13035L3.72386 5.60948L2.20299 5.68716L3.33333 4.66667L2.20299 3.64618L3.72386 3.72386L3.64618 2.20299L4.66667 3.33334L5.68715 2.20299L5.60947 3.72386L7.13034 3.64618L6 4.66667L7.13034 5.68716L5.60947 5.60948L5.68715 7.13035L4.66667 6Z",
          fill: "#FFD243"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-7.62939e-06 20H28L28 6.66667L-7.62939e-06 20Z",
          fill: "#1BAC55"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.99999 20L28 7V2.86102e-06L20.5 0L-7.62939e-06 12.5V20L6.99999 20Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.49999 20L28 5V2.86102e-06L23.5 0L-7.62939e-06 14.5V20L4.49999 20Z",
          fill: "#E52347"
        }
      )
    ]
  }
);
const VpFlagNaAsset = forwardRef(FlagNaAsset);

export { VpFlagNaAsset as default };
